import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateCurrentIssue,
  getCurrentIssue,
} from '../../entity/current-issue/model/slice/currentIssueSlice'
import { getCurrentIssueData } from '../../entity/current-issue/CurrentIssue'
import { shallowEqual } from 'react-redux'

const SiteCoverUpdateModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch()
  const currentIssueData = useSelector(getCurrentIssueData, shallowEqual)

  const validationSchema = yup.object().shape({
    number: yup.string().required('ნომერი აუცილებელია'),
    issue_url: yup.string().required('URL აუცილებელია'),
    title: yup.mixed().required('ტიტულის სურათი აუცილებელია'),
    cover: yup.mixed().required('ყდის სურათი აუცილებელია'),
    editorial: yup.mixed().required('რედაქციის სურათი აუცილებელია'),
    issn: yup.string().required('ISSN აუცილებელია'),
  })

  const initialValues = {
    number: currentIssueData?.number ?? '',
    issue_url: currentIssueData?.issue_url ?? '',
    title: currentIssueData?.title ?? null,
    cover: currentIssueData?.cover ?? null,
    editorial: currentIssueData?.editorial ?? null,
    issn: currentIssueData?.issn ?? '',
  }

  const labelMapping = {
    number: 'ნომერი',
    issue_url: 'URL',
    title: 'ტიტული (.jpg)',
    cover: 'ყდა (.jpg)',
    editorial: 'რედაქცია (.jpg)',
    issn: 'ISSN',
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const formData = new FormData()

      // Add text fields
      formData.append('number', values.number)
      formData.append('issue_url', values.issue_url)
      formData.append('issn', values.issn)

      // Handle file uploads
      if (values.title instanceof File) {
        formData.append('title', values.title)
      } else if (values.title) {
        formData.append('title', values.title)
      }

      if (values.cover instanceof File) {
        formData.append('cover', values.cover)
      } else if (values.cover) {
        formData.append('cover', values.cover)
      }

      if (values.editorial instanceof File) {
        formData.append('editorial', values.editorial)
      } else if (values.editorial) {
        formData.append('editorial', values.editorial)
      }

      dispatch(updateCurrentIssue(formData))
      dispatch(getCurrentIssue())
      onClose()
    } catch (error) {
      console.error('Error updating current issue:', error)
    } finally {
      setSubmitting(false)
    }
  }

  const renderInput = (key, formik) => {
    if (key === 'title' || key === 'cover' || key === 'editorial') {
      return (
        <Field name={key}>
          {({ field, form }) => (
            <div>
              <input
                type='file'
                accept='image/jpeg'
                onChange={event => {
                  const file = event.currentTarget.files[0]
                  form.setFieldValue(key, file)
                }}
                className='border rounded p-2'
              />
              {field.value && (
                <div className='mt-2'>
                  <img
                    src={
                      typeof field.value === 'string'
                        ? field.value
                        : URL.createObjectURL(field.value)
                    }
                    alt={key}
                    style={{ maxWidth: '200px', maxHeight: '200px' }}
                  />
                </div>
              )}
            </div>
          )}
        </Field>
      )
    } else {
      return (
        <Field
          className='border rounded py-2'
          autoComplete='off'
          type='text'
          id={key}
          name={key}
          placeholder={labelMapping[key]}
        />
      )
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>საიტის განახლება</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {formik => (
            <Form>
              <div className='flex flex-col gap-4 p-3.5'>
                {Object.keys(initialValues).map(key => (
                  <span key={key} className='flex flex-col'>
                    <label htmlFor={key} className='text-lg'>
                      {labelMapping[key]}
                    </label>
                    {renderInput(key, formik)}
                    <ErrorMessage style={{ color: 'red' }} name={key} component='span' />
                  </span>
                ))}
                <div className='flex flex-row items-center gap-3 justify-end w-full'>
                  <Button variant='primary' type='submit' disabled={formik.isSubmitting}>
                    შენახვა
                  </Button>
                  <Button onClick={onClose}>Cancel</Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default SiteCoverUpdateModal
